export function preRender(data, options) {
  const refX = findOffset(options);
  const width = arrowWidth(options.print);
  const midpoint = width / 2;
  const height = getHeight(width, midpoint);
  data.defs.marker0 = {
    tagName: 'marker',
    id: 'custom-arrow',
    refY: midpoint,
    refX,
    children: [{
      tagName: 'path',
      d: `M 0 0 L ${height} ${midpoint} L 0 ${width} Z`
    }]
  };
}

export function arrowWidth(print) {
  return print ? 3.5 : 6.5;
}

export function findOffset(options) {
  const { print, product } = options;
  const printOffset = print ? 4.25 : 8.5;
  const productOffset = product === 'wsj' ? 4 : 0;
  return printOffset + productOffset;
}

export function getHeight(width, midpoint) {
  return Math.sqrt(width * width - midpoint * midpoint);
}



// WEBPACK FOOTER //
// ./src/chart/inner/defs.js